<template>
  <div>
    <div class="xc-page">
      <div class="xc-page-main">
        <!-- 面包屑 -->
        <div class="xc-breadcrumb">
          <a href>终端管理</a>
          <a>智能面板</a>
        </div>

        <!-- 铺满 -->
        <div class="xc-row xc-s-flex content-wrap" ref="devicePage">
          <div class="device-group xc-card">
            <div class="xc-card-header">
              <div class="xc-card-title">
                门店列表
              </div>
            </div>
            <!-- 树形目录 -->
            <div class="device-tree-wrap">
              <div class="tree" v-if="stores.length">
                <el-tree 
                    :data="stores" 
                    :props="defaultProps" 
                    node-key="storeId" 
                    :default-expanded-keys="[0]" 
                    @node-click="selectFunc"
                >
                </el-tree>
              </div>
            </div>
          </div>
          <div
            class="xc-s-flex xc-card"
            style="overflow-x: hidden; display: flex; flex-direction: column"
          >
            <div class="xc-row" style="margin-bottom: 0">
              <div class="xc-card">
                <div class="xc-card-content">
                  <form class="xc-form">
                    <div
                      class="xc-form-inline"
                      style="flex-wrap: wrap; margin-bottom: 0px"
                    >
                      <xc-form-item label="MAC地址：" class="add-bottom">
                        <input type="text" class="xc-input" placeholder="请输入" v-model="mix_query.panelMac">
                      </xc-form-item>
                      <xc-form-item label="终端状态：" class="add-bottom">
                        <select
                          class="xc-select"
                          v-model="mix_query.panelStatus"
                        >
                          <option value seleced>全部</option>
                          <option value="0">在线</option>
                          <option value="1">离线</option>
                        </select>
                      </xc-form-item>
                      <div class="xc-btn-group add-bottom">
                        <button
                          type="submit"
                          class="xc-btn xc-btn-primary"
                          @click.prevent="searchList"
                        >
                          查询
                        </button>
                        <button
                          type="button"
                          class="xc-btn xc-btn-default"
                          @click="exportStore"
                        >
                          导出
                        </button>
                      </div>
                    </div>
                    <div class="xc-form-inline new-style">
                      <div class="device-info">
                        <div class="device-info-item">
                          <div class="item">
                            总计：<span>{{ deviceInfo.total }}</span>
                          </div>
                        </div>
                        <div class="device-info-item">
                          <div class="item">
                            在线：<span>{{ deviceInfo.totalOnline }}</span>
                          </div>
                        </div>
                        <div class="device-info-item">
                          <div class="item">
                            离线：<span>{{ deviceInfo.totalOffline }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!--  带滚动条表格 -->
            <div class="table-content xc-s-flex" style="overflow-x: auto">
              <div class="padding-bottom">
                <!-- 带滚动条的表格 -->
                <table class="xc-table">
                  <thead>
                    <th>门店名</th>
                    <th>房间名</th>
                    <th>终端名</th>
                    <th>在线状态</th>
                    <th>设备类型</th>
                    <th>设备MAC</th>
                    <th>Mips版本</th>
                    <th>操作</th>
                  </thead>
                  <tbody>
                    <template v-if="list && list.length">
                      <tr v-for="(item, key) in list" :key="key">
                        <td>
                          {{ item.storeName }}
                        </td>
                        <td>
                          {{ item.roomName }}
                        </td>
                        <td>
                          {{ item.panelName }}
                        </td>
                        <td>{{ item.panelStatus | getPanelStatus}}</td>
                        <td>
                          {{ item.model }}
                        </td>
                        <td>
                          {{ item.panelMac }}
                        </td>
                        <td>
                          {{ item.softwareVersion }}
                        </td>
                        <td>
                            <xc-btn-select title="管理">
                                <xc-btn-select-item title="编辑" @click.native="action('edit',item)" />
                                <xc-btn-select-item title="删除" @click.native="action('delete',item)" />
                            </xc-btn-select>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="14" class="xc-s-tac">暂无数据</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 编辑设备信息 -->
      <div
        class="xc-modal xc-modal-dialog"
        v-if="modalName =='edit'"
      >
        <div
          class="xc-modal-mask"
          @click="modalName=null"
        ></div>
        <div class="xc-modal-wrap xc-anim-scaleIn">
          <div class="xc-modal-content">
            <div class="xc-modal-header">
              <div class="xc-modal-title">编辑设备信息</div>
              <div
                class="xc-modal-close"
                @click="modalName=null"
              ></div>
            </div>
            <div class="xc-modal-body">
              <form
                class="xc-form"
                name="add"
                data-vv-scope="add"
              >
                <xc-form-item
                  label="门店名称:"
                  required
                  :error="errors.first('storeId','add')"
                >
                  <select
                    name="storeId"
                    class="xc-select"
                    v-model="fomData.storeId"
                    v-validate="'required'"
                    data-vv-as="门店名称"
                    @change="storeChange"
                  >
                    <option v-for="(item,index) in storesList" :value="item.storeId" :key="index">{{ item.storeName }}</option>
                  </select>
                  <div class="xc-form-item-error-tips">
                    {{errors.first("storeName","add")}}
                  </div>
                </xc-form-item>
                <xc-form-item
                  label="房间名:"
                  required
                  :error="errors.first('roomId','add')"
                >
                  <select
                    name="roomId"
                    class="xc-select"
                    v-model="fomData.roomId"
                    v-validate="'required'"
                    data-vv-as="房间名"
                  >
                    <option v-for="(item,index) in houseList" :value="item.roomId" :key="index">{{ item.roomName }}</option>
                  </select>
                  <div class="xc-form-item-error-tips">
                    {{errors.first("roomName","add")}}
                  </div>
                </xc-form-item>
                <xc-form-item
                  label="终端名:"
                  required
                >
                  <input
                    type="text"
                    name="panelName"
                    class="xc-input"
                    v-validate="'required'"
                    v-model="fomData.panelName"
                    data-vv-as="终端名"
                    placeholder="请输入终端名"
                    :class="{'xc-input-error':errors.first('panelName','add')}"
                  >
                  <div class="xc-form-item-error-tips">
                    {{errors.first("panelName","add")}}
                  </div>
                </xc-form-item>                        
              </form>
            </div>
            <div class="xc-modal-footer xc-flex-center">
              <div class="xc-btn-group">
                <button
                  type="button"
                  class="xc-btn xc-btn-default"
                  @click="modalName=null"
                >取消
                </button>
                <button
                  type="button"
                  class="xc-btn xc-btn-primary"
                  @click="editPanel()"
                >保存
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>
    </div>
  </div>
</template>

<script>
import houseApi from "@/api/systemHouse"
import devicePanelApi from "@/api/devicePanel";
import mixin from "../xc-ui/mixins/list";

// vee-validate验证
import "@/libs/vee-validate";
import "@/utils/form-format";

// 日期控件
import "@/libs/flatpickr";
import myLayerImport from "@/libs/myLayer";
import { mapState } from "vuex";

// ip格式化
import "@/utils/ip-format";

export default {
  name: "devicePanel",
  data() {
    return {
      id: 0,
      stores: [], //门店列表
      storesList: [], //门店列表
      houseList: [], //房间列表
      //合并input框后的选择的值
      changeItem: "MAC地址",
      searchInfo: "",

      // 列表key
      mix_listKey: "list",

      // 列表唯一字段
      mix_listId: "departmentId",

      list: [],

      // 默认查询参数
      mix_query: {
        panelStatus: "",
        panelMac: "",
        storeId: "",
        // programDue: "",
      },

      // 弹出窗
      modalName: null,

      modalData: {
        title: "我是标题",
      },
      moveToGroupParentId: "",
      deviceInfo: {
        total: null,
        totalOffline: null,
        totalOnline: null,
      },
      // 导出查询参数
      obj: {
        panelStatus: "",
        panelMac: "",
        storeId: "",
        pageNum: 1,
        pageSize: 0,
      },
      defaultProps: {
        children: 'children',
        label: 'storeName'
      },
      fomData: {},
    };
  },

  mounted() {
    // 获取浏览器可视区域高度
    let clientHeight = `${document.documentElement.clientHeight}`; 
    if (this.$refs.devicePage && clientHeight) {
      this.$refs.devicePage.style.height = clientHeight - 120 + "px";
    }
    this.getStoreList();
  },

  computed: {
    ...mapState(["globalConfig", "userModule"]), // 异步 页面需判断userModule是否获取到
  },

  async created() {
    // 加载JS
    await myLayerImport();
  },

  watch: {
    // modalName(newValue) {
    //   if (newValue == null) {
    //     (this.deviceGroupId = ""), (this.moveToGroupParentId = "");
    //   }
    // },
    // //监测下拉选择框的值改变后，来变化这个值
    // changeItem: function () {
    //   this.searchInfo = "";
    //   this.mix_query.panelMac = "";
    // },
    // searchInfo: function (value) {
    //   if (this.changeItem == "MAC地址") {
    //     this.mix_query.panelMac = value;
    //   } 
    // },
  },
  filters: {
    getPanelStatus: function (value) {
      if (value == 0) {
        return "在线"
      }
      return "离线";
    }
  },
  methods: {
    //获取门店列表数据
    getStoreList() {
        var _this = this;
        houseApi.getStoreSelectList().then(function (ret) {
          _this.storesList = ret.data;
          _this.stores.push({ storeId: 0, storeName: `全部(${ret.data.length})`,children:ret.data})

        }).catch(function (error) {
            console.log(error)
        });
    },
    searchList() {
      this.mix_search();
      this.obj = {
        pageNum: 1,
        pageSize: 0,
        ...this.mix_query,
      };
    },
    //导出列表
    exportStore() {
      devicePanelApi
        .exportPanelDevice({
          responseType: "blob",
          params: this.obj,
        })
        .then((v) => {
          this.$message.success("导出成功");
          let url = window.URL.createObjectURL(new Blob([v]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "智能面板列表.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((res) => {
          console.log(res);
        });
    },

    // 操作
    action(action, item) {
        if (action == 'edit') {
          var _this = this;
          houseApi.getRoomSelectList({params:{storeId:item.storeId}}).then(function (ret) {
            _this.houseList = ret.data;
            _this.modalName = 'edit';
            _this.fomData = {
                ...item
            }
          }).catch(function (error) {
              console.log(error)
          });
        } else if (action == 'delete') {
            this.$xc.confirm({
                title: '删除',
                msg: '确认删除该设备？',
            }).then(() => {
                devicePanelApi.deletePanel(item.panelId).then(v => {
                    this.$message.success(v.msg);
                    this.initData();
                })

            })
        }
    },
    //获取门店下的房间列表数据
    storeChange(){
      let _this = this;
      houseApi.getRoomSelectList({params:{storeId:this.fomData.storeId}}).then(function (ret) {
        _this.fomData.roomId = ''
        _this.houseList = ret.data;
        if(_this.houseList.length <= 0){
          _this.$message.warning("此门店下没有房间数据，请先添加房间数据再进行设备修改操作！");
        }
      }).catch(function (error) {
          console.log(error)
      });
    },

    // 初始化数据
    initData() {
      // 默认搜索的数据
      const search = {
        pageNum: 1,
        pageSize: 0,
        ...this.mix_query,
      };

      devicePanelApi.getPanelList({params:search}).then((v) => {
        let ret = v;
        this.list = this.mix_format(ret.data.list);
        this.deviceInfo.total = ret.data.total;
        this.deviceInfo.totalOffline = ret.data.totalOffline;
        this.deviceInfo.totalOnline = ret.data.totalOnline;
      });
    },

    // 树形点击文字的回调
    selectFunc: function (data) {
      let storeId = "";
      if (data) {
        if (data.storeId === 0) {
         storeId = ""
        } else {
          storeId = data.storeId
        }
      } 
      this.mix_query.storeId = storeId;
      this.initData();
    },
    layer(options) {
      layer.open({
        type: 2,
        title: false,
        closeBtn: 0,
        shadeClose: true,
        area: ["672px", "379px"],
        ...options,
      });
    },
    // 编辑设备信息
    editPanel: function () {
      var myForm = document.add;
      // 验证器命名空间
      const scope = 'add';
      this.$validator.validateAll(scope).then(validate => {
        if (validate) {
          const data = this.$formFormat(myForm);
          data.panelId = this.fomData.panelId;
          devicePanelApi.editPanel(data).then(() => {
            this.$message.success("修改成功");
            this.modalName = null;
            this.initData();
          })
        } else {
            return false;
        }
      })
    },
  },
  mixins: [mixin],
};
</script>

<style scoped lang="scss">
.xc-page {
  height: 100%;
  flex: 1;
}

.table-content {
  margin: 0px 20px;
}

.device-tree-wrap {
  position: relative;
  overflow: auto;
  height: calc(100% - 47px);
  height: -webkit-calc(100% - 47px);
  padding: 20px 20px 20px 10px;
  box-sizing: border-box;
  display: flex;
}

.tree {
  flex: 1;
  height: 100%;
  padding-right: 10px;
  box-sizing: border-box;
}



::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #cfd5e0;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #cfd5e0;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #cfd5e0;
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #cfd5e0;
}


.device-group {
  width: 300px;
  // margin-right: 16px;
}

.xc-card-content {
  padding: 0 0;
  margin: 24px 20px;
}

.padding-bottom {
  padding-bottom: 24px;
}

.xc-home-container .xc-home-content .xc-page-main > .xc-row:last-child {
  padding-bottom: 0;
}



.new-style {
  justify-content: space-between;
  align-items: center;
}

.device-info {
  display: flex;
  // margin-bottom:24px;
  .device-info-item {
    margin-right: 20px;
    font-size: 14px;
  }
}

.add-bottom {
  margin-bottom: 24px;
  .xc-btn {
    min-width: 50px;
  }
}



</style>
